// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3oBBZ","dragIcon":"Choice_dragIcon__mfNnF","left":"Choice_left__3BUaU","input":"Choice_input__X7BdM"};